(function () {
  window.__DripstockSizeConfidence = window.__DripstockSizeConfidence || {};


  // Reliable fallback opener for the new Find My Size trigger.
  document.addEventListener('click', function (event) {
    const trigger = event.target && event.target.closest
      ? event.target.closest('[data-ds-size-open]')
      : null;
    if (!trigger) return;

    const finder = trigger.closest('[data-ds-size-finder]');
    if (!finder) return;

    const dialog = finder.querySelector('[data-ds-size-dialog]');
    if (!dialog) return;

    const inputsView = finder.querySelector('[data-ds-size-inputs]');
    const resultView = finder.querySelector('[data-ds-size-result]');
    const selectStatus = finder.querySelector('[data-ds-select-status]');

    if (inputsView) inputsView.hidden = false;
    if (resultView) resultView.hidden = true;
    if (selectStatus) selectStatus.hidden = true;

    if (!dialog.open) {
      try {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      } catch (error) {
        dialog.setAttribute('open', '');
      }
    }
  }, true);

  function initDripstockSizeFinder(root) {
      if (!root || root.dataset.dsSizeFinderReady === '1') return;
      root.dataset.dsSizeFinderReady = '1';

      const dialog = root.querySelector('[data-ds-size-dialog]');
      const openButton = root.querySelector('[data-ds-size-open]');
      const closeButton = root.querySelector('[data-ds-size-close]');
      const calculateButton = root.querySelector('[data-ds-size-calculate]');
      const againButton = root.querySelector('[data-ds-size-again]');
      const useButton = root.querySelector('[data-ds-size-use]');
      const inputsView = root.querySelector('[data-ds-size-inputs]');
      const resultView = root.querySelector('[data-ds-size-result]');
      const heightInput = root.querySelector('[data-ds-height]');
      const weightInput = root.querySelector('[data-ds-weight]');
      const chestInput = root.querySelector('[data-ds-chest]');
      const errorBox = root.querySelector('[data-ds-size-error]');
      const resultSize = root.querySelector('[data-ds-result-size]');
      const resultCopy = root.querySelector('[data-ds-result-copy]');
      const resultMeasurements = root.querySelector('[data-ds-garment-measurements]');
      const resultNote = root.querySelector('[data-ds-result-note]');
      const alternativeWrap = root.querySelector('[data-ds-alternative-wrap]');
      const alternativeLabel = root.querySelector('[data-ds-alternative-label]');
      const alternativeSize = root.querySelector('[data-ds-alternative]');
      const confidence = root.querySelector('[data-ds-confidence]');
      const confidenceDot = root.querySelector('[data-ds-confidence-dot]');
      const selectStatus = root.querySelector('[data-ds-select-status]');

      const kind = root.dataset.kind;
      const productId = root.dataset.productId;
      const defaultFit = 'Oversized';

      const BODY_RANGES = [
        { size: 'XS', h: [150, 158], w: [40, 47] },
        { size: 'S', h: [157, 163], w: [45, 51] },
        { size: 'M', h: [162, 170], w: [50, 58] },
        { size: 'L', h: [168, 176], w: [57, 67] },
        { size: 'XL', h: [174, 183], w: [65, 78] },
        { size: 'XXL', h: [180, 190], w: [76, 90] },
        { size: '3XL', h: [185, 195], w: [88, 105] }
      ];

      const GARMENTS = {
        regularHoodie: [
          { size: 'XS', width: 50, length: 64 },
          { size: 'S', width: 52, length: 66 },
          { size: 'M', width: 54, length: 70 },
          { size: 'L', width: 56, length: 72 },
          { size: 'XL', width: 58, length: 74 },
          { size: 'XXL', width: 60, length: 76 },
          { size: '3XL', width: 62, length: 78 }
        ],
        oversizedHoodie: [
          { size: 'XS', width: 58, length: 68 },
          { size: 'S', width: 60, length: 70 },
          { size: 'M', width: 62, length: 72 },
          { size: 'L', width: 64, length: 74 },
          { size: 'XL', width: 66, length: 76 },
          { size: 'XXL', width: 68, length: 78 },
          { size: '3XL', width: 70, length: 80 }
        ],
        zipup: [
          { size: 'XS', width: 50, length: 64 },
          { size: 'S', width: 52, length: 66 },
          { size: 'M', width: 54, length: 70 },
          { size: 'L', width: 56, length: 72 },
          { size: 'XL', width: 58, length: 74 },
          { size: 'XXL', width: 60, length: 76 },
          { size: '3XL', width: 62, length: 78 }
        ],
        sweatshirt: [
          { size: 'XS', width: 48, length: 62 },
          { size: 'S', width: 50, length: 64 },
          { size: 'M', width: 52, length: 68 },
          { size: 'L', width: 54, length: 70 },
          { size: 'XL', width: 56, length: 72 },
          { size: 'XXL', width: 58, length: 74 },
          { size: '3XL', width: 60, length: 76 }
        ],
        cropped: [
          { size: 'S', width: 48, length: 52 },
          { size: 'M', width: 50, length: 54 },
          { size: 'L', width: 52, length: 56 },
          { size: 'XL', width: 54, length: 58 },
          { size: 'XXL', width: 56, length: 60 },
          { size: '3XL', width: 58, length: 62 }
        ],
        pants: [
          { size: 'S', waist: 48, length: 99, anchorH: 160, anchorW: 52 },
          { size: 'M', waist: 52, length: 102, anchorH: 170, anchorW: 65 },
          { size: 'L', waist: 54, length: 104, anchorH: 179, anchorW: 80 },
          { size: 'XL', waist: 57, length: 107, anchorH: 187, anchorW: 94 },
          { size: 'XXL', waist: 60, length: 110, anchorH: 194, anchorW: 108 }
        ]
      };

      let lastRecommendation = window.__DripstockSizeConfidence[productId] || null;

      function displaySize(size) {
        return size === 'XXL' ? '2XL' : size;
      }

      function normalizeSize(size) {
        return String(size || '')
          .trim()
          .toUpperCase()
          .replace(/\s+/g, '')
          .replace(/^2XL$/, 'XXL')
          .replace(/^XXXL$/, '3XL');
      }

      function getProductVariantPicker() {
        return document.querySelector('variant-picker[data-product-id="' + productId + '"]');
      }

      function getSizeField(picker) {
        if (!picker) return null;

        const sizeRadio = picker.querySelector('input[data-option-name="Size"]');
        if (sizeRadio) return sizeRadio.closest('fieldset') || sizeRadio.closest('.variant-option');

        const selects = Array.from(picker.querySelectorAll('select'));
        return selects.find(function (select) {
          const label = select.closest('.variant-option')?.querySelector('label, legend');
          return label && /size/i.test(label.textContent || '');
        })?.closest('.variant-option') || null;
      }

      function clearSizeConfidenceVisuals(picker) {
        if (!picker) return;
        picker.querySelectorAll('.ds-size-recommended-option').forEach(function (label) {
          label.classList.remove('ds-size-recommended-option');
        });
      }

      function applySizeConfidence(rec) {
        if (!rec) return;

        const picker = getProductVariantPicker();
        if (!picker) return;

        clearSizeConfidenceVisuals(picker);

        const control = findSizeControl(rec.size);
        if (control && control.type === 'radio') {
          const label = control.element.closest('label');
          if (label) label.classList.add('ds-size-recommended-option');
        }

        let strip = picker.querySelector('[data-ds-size-confidence-label]');
        if (!strip) {
          strip = document.createElement('div');
          strip.className = 'ds-size-confidence-strip';
          strip.setAttribute('data-ds-size-confidence-label', '');
          strip.setAttribute('role', 'status');

          const sizeField = getSizeField(picker);
          if (sizeField && sizeField.parentNode) {
            sizeField.parentNode.insertBefore(strip, sizeField);
          } else {
            picker.prepend(strip);
          }
        }

        const desiredMain = 'Recommended for you: ' + displaySize(rec.size) + ' ✓';
        const desiredDetail =
          kind === 'set' && rec.topSize && rec.pantsSize
            ? 'Top: ' + displaySize(rec.topSize) +
              ' · Pants: ' + displaySize(rec.pantsSize) +
              ' · Based on your height & weight'
            : 'Based on your height & weight';

        let main = strip.querySelector('strong');
        let detail = strip.querySelector('span');

        if (!main) {
          main = document.createElement('strong');
          strip.appendChild(main);
        }
        if (!detail) {
          detail = document.createElement('span');
          strip.appendChild(detail);
        }

        if (main.textContent !== desiredMain) main.textContent = desiredMain;
        if (detail.textContent !== desiredDetail) detail.textContent = desiredDetail;
      }

      let sizeConfidencePickerObserver = null;
      let observedSizeConfidencePicker = null;
      let sizeConfidenceReapplyQueued = false;

      function ensureSizeConfidenceWatcher() {
        const picker = getProductVariantPicker();
        if (!picker) return;

        if (observedSizeConfidencePicker === picker && sizeConfidencePickerObserver) return;

        if (sizeConfidencePickerObserver) sizeConfidencePickerObserver.disconnect();

        observedSizeConfidencePicker = picker;
        sizeConfidencePickerObserver = new MutationObserver(function () {
          if (!lastRecommendation || sizeConfidenceReapplyQueued) return;

          sizeConfidenceReapplyQueued = true;
          window.requestAnimationFrame(function () {
            sizeConfidenceReapplyQueued = false;

            const currentPicker = getProductVariantPicker();
            if (currentPicker !== observedSizeConfidencePicker) {
              ensureSizeConfidenceWatcher();
            }

            if (lastRecommendation) {
              applySizeConfidence(lastRecommendation);
            }
          });
        });

        sizeConfidencePickerObserver.observe(picker, {
          childList: true,
          subtree: true
        });
      }

      function refreshSizeConfidenceSoon() {
        if (!lastRecommendation) return;

        ensureSizeConfidenceWatcher();

        [80, 240, 700, 1400].forEach(function (delay) {
          window.setTimeout(function () {
            if (!lastRecommendation) return;
            ensureSizeConfidenceWatcher();
            applySizeConfidence(lastRecommendation);
          }, delay);
        });
      }

      function rangeDistance(value, min, max) {
        const span = Math.max(1, max - min);
        if (value < min) return (min - value) / span;
        if (value > max) return (value - max) / span;
        return 0;
      }

      function bodyScore(entry, h, w) {
        const hSpan = Math.max(1, entry.h[1] - entry.h[0]);
        const wSpan = Math.max(1, entry.w[1] - entry.w[0]);
        const hCenter = (entry.h[0] + entry.h[1]) / 2;
        const wCenter = (entry.w[0] + entry.w[1]) / 2;

        const outside =
          rangeDistance(h, entry.h[0], entry.h[1]) * 0.9 +
          rangeDistance(w, entry.w[0], entry.w[1]) * 1.15;

        const center =
          (Math.abs(h - hCenter) / hSpan) * 0.10 +
          (Math.abs(w - wCenter) / wSpan) * 0.13;

        return outside + center;
      }

      function getBaseTop(h, w) {
        return BODY_RANGES
          .map(function (entry) {
            return { entry: entry, score: bodyScore(entry, h, w) };
          })
          .sort(function (a, b) { return a.score - b.score; });
      }

      function getFit() {
        return 'Oversized';
      }

      function syncFitFromProductPage() {
        return;
      }

      function adjustNormalReferenceForChest(baseRef, chest) {
        if (!chest || !Number.isFinite(chest)) return baseRef;

        const desiredHalfWidth = (chest / 2) + 7;
        const ranked = GARMENTS.regularHoodie
          .map(function (g) {
            const widthPenalty = Math.abs(g.width - desiredHalfWidth) * 1.25;
            const lengthPenalty = Math.abs(g.length - baseRef.length) * 0.45;
            return { garment: g, score: widthPenalty + lengthPenalty };
          })
          .sort(function (a, b) { return a.score - b.score; });

        return ranked[0].garment;
      }

      function rankAgainstTarget(dataset, targetWidth, targetLength, widthWeight, lengthWeight) {
        return dataset
          .map(function (g) {
            return {
              garment: g,
              score:
                Math.abs(g.width - targetWidth) * widthWeight +
                Math.abs(g.length - targetLength) * lengthWeight
            };
          })
          .sort(function (a, b) { return a.score - b.score; });
      }

      function recommendTop(h, w, chest) {
        const bodyRanked = getBaseTop(h, w);
        const baseBody = bodyRanked[0].entry;
        let normalRef = GARMENTS.regularHoodie.find(function (g) { return g.size === baseBody.size; });
        normalRef = adjustNormalReferenceForChest(normalRef, chest);

        let ranked;
        let cutLabel = '';
        let note = '';
        let confidenceLevel = chest ? 'HIGH CONFIDENCE' : 'GOOD CONFIDENCE';

        if (kind === 'hoodie') {
          const fit = getFit();
          if (fit === 'Oversized') {
            ranked = rankAgainstTarget(
              GARMENTS.oversizedHoodie,
              normalRef.width + 6,
              normalRef.length,
              1.0,
              1.2
            );
            cutLabel = 'oversized hoodie';
          } else {
            ranked = rankAgainstTarget(
              GARMENTS.regularHoodie,
              normalRef.width,
              normalRef.length,
              1.0,
              1.0
            );
            cutLabel = 'regular hoodie';
          }
        } else if (kind === 'zipup') {
          if (defaultFit === 'Oversized') {
            ranked = rankAgainstTarget(
              GARMENTS.oversizedHoodie,
              normalRef.width + 6,
              normalRef.length,
              1.0,
              1.2
            );
            cutLabel = 'oversized zip-up';
            confidenceLevel = chest ? 'GOOD CONFIDENCE' : 'MEDIUM CONFIDENCE';
            note = 'The factory sheet provides a normal-fit zip-up chart, not a separate oversized zip-up chart. This oversized result uses the measured oversized hoodie cut as the closest calibration.';
          } else {
            ranked = rankAgainstTarget(
              GARMENTS.zipup,
              normalRef.width,
              normalRef.length,
              1.0,
              1.0
            );
            cutLabel = 'normal-fit zip-up';
          }
        } else if (kind === 'sweatshirt') {
          ranked = rankAgainstTarget(
            GARMENTS.sweatshirt,
            normalRef.width,
            normalRef.length,
            1.15,
            1.0
          );
          cutLabel = 'normal-fit sweatshirt';
        } else if (kind === 'cropped') {
          ranked = GARMENTS.cropped
            .map(function (g) {
              return {
                garment: g,
                score: Math.abs(g.width - normalRef.width) * 1.4
              };
            })
            .sort(function (a, b) { return a.score - b.score; });
          cutLabel = 'cropped hoodie';
          note = 'Cropped length is intentional, so the recommendation prioritizes chest room rather than matching a standard hoodie length.';
        } else {
          return null;
        }

        const primary = ranked[0];
        const secondary = ranked[1] || null;
        const outsideVerified =
          h < 150 || h > 195 || w < 40 || w > 105 ||
          (chest && (chest < 70 || chest > 150));

        if (outsideVerified) confidenceLevel = 'LOW CONFIDENCE';
        else if (!chest && secondary && Math.abs(secondary.score - primary.score) < 0.8) {
          confidenceLevel = 'MEDIUM CONFIDENCE';
        }

        const primaryIndex = ranked.findIndex(function (x) { return x.garment.size === primary.garment.size; });
        const secondaryIndex = secondary
          ? ranked.findIndex(function (x) { return x.garment.size === secondary.garment.size; })
          : -1;

        return {
          size: primary.garment.size,
          alternative: secondary ? secondary.garment.size : null,
          alternativeLabel: secondary
            ? (GARMENTS.regularHoodie.findIndex(function (g) { return g.size === secondary.garment.size; }) >
               GARMENTS.regularHoodie.findIndex(function (g) { return g.size === primary.garment.size; })
                ? 'Roomier option'
                : 'Closer option')
            : '',
          width: primary.garment.width,
          length: primary.garment.length,
          confidence: confidenceLevel,
          note: note,
          copy:
            'For ' + Math.round(h) + ' cm / ' + Math.round(w) + ' kg' +
            (chest ? ' with a ' + Math.round(chest) + ' cm chest' : '') +
            ', this is the best match for the ' + cutLabel + '.',
          fit: kind === 'hoodie' ? getFit() : defaultFit,
          outsideVerified: outsideVerified
        };
      }


      function recommendSet(h, w, chest) {
        const fullSizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];

        const bodyRanked = getBaseTop(h, w);
        const baseBody = bodyRanked[0].entry;
        let normalRef = GARMENTS.regularHoodie.find(function (g) {
          return g.size === baseBody.size;
        });
        normalRef = adjustNormalReferenceForChest(normalRef, chest);

        const topRanked = rankAgainstTarget(
          GARMENTS.oversizedHoodie,
          normalRef.width + 6,
          normalRef.length,
          1.0,
          1.2
        );

        const pantsRanked = GARMENTS.pants
          .map(function (g) {
            const heightPart = Math.pow((h - g.anchorH) / 9, 2) * 0.45;
            const weightPart = Math.pow((w - g.anchorW) / 13, 2) * 0.55;
            return { garment: g, score: heightPart + weightPart };
          })
          .sort(function (a, b) { return a.score - b.score; });

        const topSize = topRanked[0].garment.size;
        const pantsSize = pantsRanked[0].garment.size;
        const topIndex = fullSizes.indexOf(topSize);
        const pantsIndex = fullSizes.indexOf(pantsSize);
        const combinedIndex = Math.max(
          0,
          Math.min(fullSizes.length - 1, Math.round((topIndex + pantsIndex) / 2))
        );
        const size = fullSizes[combinedIndex];

        const topGarment = GARMENTS.oversizedHoodie.find(function (g) {
          return g.size === size;
        });
        const pantsGarment = GARMENTS.pants.find(function (g) {
          return g.size === size;
        });

        const difference = Math.abs(topIndex - pantsIndex);
        const outsideVerified =
          h < 150 || h > 200 || w < 40 || w > 120 ||
          (chest && (chest < 70 || chest > 150));

        let confidenceLevel = 'GOOD CONFIDENCE';
        if (outsideVerified || difference >= 2) confidenceLevel = 'LOW CONFIDENCE';
        else if (difference === 1) confidenceLevel = 'MEDIUM CONFIDENCE';
        else if (chest) confidenceLevel = 'HIGH CONFIDENCE';

        return {
          size: size,
          alternative: null,
          alternativeLabel: '',
          confidence: confidenceLevel,
          note:
            'This balances the oversized top recommendation (' + displaySize(topSize) +
            ') with the sweatpants recommendation (' + displaySize(pantsSize) +
            ') so the full set can use one size.',
          copy:
            'For ' + Math.round(h) + ' cm / ' + Math.round(w) + ' kg' +
            (chest ? ' with a ' + Math.round(chest) + ' cm chest' : '') +
            ', ' + displaySize(size) + ' is the best single size for the full set.',
          topWidth: topGarment ? topGarment.width : null,
          topLength: topGarment ? topGarment.length : null,
          pantsWaist: pantsGarment ? pantsGarment.waist : null,
          pantsLength: pantsGarment ? pantsGarment.length : null,
          fit: '',
          topSize: topSize,
          pantsSize: pantsSize,
          outsideVerified: outsideVerified
        };
      }

      function recommendPants(h, w) {
        let ranked = GARMENTS.pants
          .map(function (g) {
            const heightPart = Math.pow((h - g.anchorH) / 9, 2) * 0.45;
            const weightPart = Math.pow((w - g.anchorW) / 13, 2) * 0.55;
            return { garment: g, score: heightPart + weightPart };
          })
          .sort(function (a, b) { return a.score - b.score; });

        const primary = ranked[0];

        const alternatives = GARMENTS.pants
          .filter(function (g) { return g.size !== primary.garment.size; })
          .map(function (g) {
            const heightPart = Math.pow((h - g.anchorH) / 9, 2) * 0.45;
            const weightPart = Math.pow((w - g.anchorW) / 13, 2) * 0.55;
            return { garment: g, score: heightPart + weightPart };
          })
          .sort(function (a, b) { return a.score - b.score; });

        const secondary = alternatives[0] || null;
        const outsideVerified = h < 150 || h > 200 || w < 40 || w > 120;
        let confidenceLevel = outsideVerified ? 'LOW CONFIDENCE' : 'GOOD CONFIDENCE';

        if (!outsideVerified && secondary && Math.abs(secondary.score - primary.score) < 0.22) {
          confidenceLevel = 'MEDIUM CONFIDENCE';
        }

        const primaryIndex = GARMENTS.pants.findIndex(function (g) { return g.size === primary.garment.size; });
        const secondaryIndex = secondary
          ? GARMENTS.pants.findIndex(function (g) { return g.size === secondary.garment.size; })
          : -1;

        return {
          size: primary.garment.size,
          alternative: secondary ? secondary.garment.size : null,
          alternativeLabel: secondary
            ? (secondaryIndex > primaryIndex ? 'Roomier / longer option' : 'Closer / shorter option')
            : '',
          waist: primary.garment.waist,
          length: primary.garment.length,
          confidence: confidenceLevel,
          note: 'Sweatpants are calibrated from the factory garment lengths and a confirmed Dripstock fit of L at 179 cm / 80 kg.',
          copy:
            'For ' + Math.round(h) + ' cm / ' + Math.round(w) + ' kg, this is the strongest sweatpants size match.',
          fit: '',
          outsideVerified: outsideVerified
        };
      }

      function showError(message) {
        errorBox.textContent = message;
        errorBox.hidden = false;
      }

      function clearError() {
        errorBox.textContent = '';
        errorBox.hidden = true;
      }

      function getRecommendation() {
        clearError();
        if (selectStatus) selectStatus.hidden = true;

        const h = Number(heightInput.value);
        const w = Number(weightInput.value);
        const chest = chestInput ? Number(chestInput.value) : 0;

        if (!Number.isFinite(h) || h < 140 || h > 205) {
          showError('Enter a height between 140 and 205 cm.');
          heightInput.focus();
          return null;
        }

        if (!Number.isFinite(w) || w < 35 || w > 130) {
          showError('Enter a weight between 35 and 130 kg.');
          weightInput.focus();
          return null;
        }

        if (chestInput && chestInput.value && (!Number.isFinite(chest) || chest < 70 || chest > 150)) {
          showError('If you enter chest size, use a measurement between 70 and 150 cm.');
          chestInput.focus();
          return null;
        }

        if (kind === 'pants') return recommendPants(h, w);
        if (kind === 'set') return recommendSet(h, w, chest || 0);
        return recommendTop(h, w, chest || 0);
      }

      let sizeResultAudioContext = null;

      function playSizeResultSound() {
    if (window.DripstockSound && !window.DripstockSound.enabled()) return;
        try {
          const AudioCtx = window.AudioContext || window.webkitAudioContext;
          if (!AudioCtx) return;

          if (!sizeResultAudioContext) sizeResultAudioContext = new AudioCtx();
          if (sizeResultAudioContext.state === 'suspended') {
            sizeResultAudioContext.resume();
          }

          const now = sizeResultAudioContext.currentTime;
          const master = sizeResultAudioContext.createGain();
          master.gain.setValueAtTime(0.0001, now);
          master.gain.exponentialRampToValueAtTime(0.075, now + 0.012);
          master.gain.exponentialRampToValueAtTime(0.0001, now + 0.52);
          master.connect(sizeResultAudioContext.destination);

          [
            { frequency: 698.46, start: 0.00, duration: 0.20 },
            { frequency: 1046.50, start: 0.13, duration: 0.32 }
          ].forEach(function (note) {
            const oscillator = sizeResultAudioContext.createOscillator();
            const gain = sizeResultAudioContext.createGain();

            oscillator.type = 'sine';
            oscillator.frequency.setValueAtTime(note.frequency, now + note.start);

            gain.gain.setValueAtTime(0.0001, now + note.start);
            gain.gain.exponentialRampToValueAtTime(0.12, now + note.start + 0.015);
            gain.gain.exponentialRampToValueAtTime(0.0001, now + note.start + note.duration);

            oscillator.connect(gain);
            gain.connect(master);
            oscillator.start(now + note.start);
            oscillator.stop(now + note.start + note.duration + 0.03);
          });
        } catch (error) {}
      }

      function renderRecommendation(rec) {
        if (!rec) return;
        lastRecommendation = rec;
        window.__DripstockSizeConfidence[productId] = rec;
        ensureSizeConfidenceWatcher();
        applySizeConfidence(rec);
        refreshSizeConfidenceSoon();

        resultSize.textContent = displaySize(rec.size);
        resultCopy.textContent = rec.copy;
        confidence.textContent = rec.confidence;

        if (rec.confidence === 'HIGH CONFIDENCE') confidenceDot.style.opacity = '1';
        else if (rec.confidence === 'GOOD CONFIDENCE') confidenceDot.style.opacity = '.82';
        else if (rec.confidence === 'MEDIUM CONFIDENCE') confidenceDot.style.opacity = '.55';
        else confidenceDot.style.opacity = '.35';

        if (kind === 'pants') {
          resultMeasurements.textContent =
            displaySize(rec.size) + ': ' + rec.waist + ' cm waist width × ' + rec.length + ' cm total length';
        } else if (kind === 'set') {
          const setParts = [];
          if (rec.topWidth && rec.topLength) {
            setParts.push('Top: ' + rec.topWidth + ' cm width × ' + rec.topLength + ' cm length');
          }
          if (rec.pantsWaist && rec.pantsLength) {
            setParts.push('Pants: ' + rec.pantsWaist + ' cm waist width × ' + rec.pantsLength + ' cm length');
          }
          resultMeasurements.textContent =
            setParts.length ? setParts.join(' · ') : 'Combined top + pants sizing';
        } else {
          resultMeasurements.textContent =
            displaySize(rec.size) + ': ' + rec.width + ' cm chest width × ' + rec.length + ' cm body length';
        }

        if (rec.alternative) {
          alternativeWrap.hidden = false;
          alternativeLabel.textContent = rec.alternativeLabel;
          alternativeSize.textContent = displaySize(rec.alternative);
        } else {
          alternativeWrap.hidden = true;
        }

        let note = rec.note || '';
        if (rec.outsideVerified) {
          note += (note ? ' ' : '') + 'Your measurements are outside the strongest verified range, so contact us if you want a manual double-check.';
        }
        resultNote.textContent = note;

        inputsView.hidden = true;
        resultView.hidden = false;
        playSizeResultSound();
      }

      function findSizeControl(size) {
        const normalizedTarget = normalizeSize(size);
        const picker = document.querySelector('variant-picker[data-product-id="' + productId + '"]');
        if (!picker) return null;

        const radios = Array.from(picker.querySelectorAll('input[data-option-name="Size"]'));
        const radio = radios.find(function (input) {
          return normalizeSize(input.value) === normalizedTarget;
        });
        if (radio) return { type: 'radio', element: radio };

        const selects = Array.from(picker.querySelectorAll('select'));
        for (const select of selects) {
          const option = Array.from(select.options).find(function (opt) {
            return normalizeSize(opt.value) === normalizedTarget;
          });
          if (option) return { type: 'select', element: select, option: option };
        }

        return null;
      }

      function syncProductFit(rec) {
        if (!rec || kind !== 'hoodie') return;

        const component = root.closest('product-form-component');
        if (component) {
          const propertyRadio = Array.from(component.querySelectorAll('.dripstock-fit-selector input')).find(function (input) {
            return input.value === rec.fit;
          });
          if (propertyRadio) {
            propertyRadio.checked = true;
            propertyRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        const picker = document.querySelector('variant-picker[data-product-id="' + productId + '"]');
        if (picker) {
          const variantFit = Array.from(picker.querySelectorAll('input[data-option-name="Fit"], input[data-option-name="Cut"]')).find(function (input) {
            return String(input.value).toLowerCase() === String(rec.fit).toLowerCase();
          });
          if (variantFit && !variantFit.disabled) {
            variantFit.click();
          }
        }
      }

      function useRecommendation() {
        if (!lastRecommendation) return;

        syncProductFit(lastRecommendation);
        const control = findSizeControl(lastRecommendation.size);

        if (!control) {
          selectStatus.textContent = 'Recommended: ' + displaySize(lastRecommendation.size) + '. Select it from the size options above.';
          selectStatus.hidden = false;
          return;
        }

        if (control.type === 'radio') {
          if (control.element.disabled || control.element.getAttribute('aria-disabled') === 'true') {
            selectStatus.textContent =
              displaySize(lastRecommendation.size) + ' is recommended, but it is unavailable with the current selection.';
            selectStatus.hidden = false;
            return;
          }
          control.element.click();
        } else {
          if (control.option.disabled) {
            selectStatus.textContent =
              displaySize(lastRecommendation.size) + ' is recommended, but it is unavailable with the current selection.';
            selectStatus.hidden = false;
            return;
          }
          control.element.value = control.option.value;
          control.element.dispatchEvent(new Event('change', { bubbles: true }));
        }

        refreshSizeConfidenceSoon();

        selectStatus.textContent = displaySize(lastRecommendation.size) + ' selected.';
        selectStatus.hidden = false;

        window.setTimeout(function () {
          if (dialog && dialog.open) dialog.close();
        }, 650);
      }

      function resetResult() {
        resultView.hidden = true;
        inputsView.hidden = false;
        if (selectStatus) selectStatus.hidden = true;
      }

      openButton.addEventListener('click', function () {
        syncFitFromProductPage();
        resetResult();
        if (dialog && !dialog.open) {
          try {
            if (typeof dialog.showModal === 'function') dialog.showModal();
            else dialog.setAttribute('open', '');
          } catch (error) {
            dialog.setAttribute('open', '');
          }
        }
      });

      closeButton.addEventListener('click', function () {
        if (dialog && dialog.open) dialog.close();
      });

      calculateButton.addEventListener('click', function () {
        const rec = getRecommendation();
        if (rec) renderRecommendation(rec);
      });

      againButton.addEventListener('click', resetResult);
      useButton.addEventListener('click', useRecommendation);

      [heightInput, weightInput, chestInput].filter(Boolean).forEach(function (input) {
        input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            const rec = getRecommendation();
            if (rec) renderRecommendation(rec);
          }
        });
      });

      root.setAttribute('data-ds-size-confidence-change-listener', '1');

      document.addEventListener('change', function (event) {
        if (!lastRecommendation) return;
        const picker = event.target && event.target.closest
          ? event.target.closest('variant-picker[data-product-id="' + productId + '"]')
          : null;
        if (!picker) return;
        refreshSizeConfidenceSoon();
      });

      root.__dsRestoreSizeConfidence = function () {
        lastRecommendation = window.__DripstockSizeConfidence[productId] || lastRecommendation;
        if (!lastRecommendation) return;
        ensureSizeConfidenceWatcher();
        refreshSizeConfidenceSoon();
      };

      if (lastRecommendation) {
        ensureSizeConfidenceWatcher();
        refreshSizeConfidenceSoon();
      }

      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        const inside =
          event.clientX >= rect.left &&
          event.clientX <= rect.right &&
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom;
        if (!inside) dialog.close();
      });
      }

  function initAllSizeFinders(scope) {
    const base = scope && scope.querySelectorAll ? scope : document;
    const roots = [];

    if (base.matches && base.matches('[data-ds-size-finder]')) roots.push(base);
    if (base.querySelectorAll) {
      base.querySelectorAll('[data-ds-size-finder]').forEach(function (root) {
        roots.push(root);
      });
    }

    roots.forEach(initDripstockSizeFinder);
  }

  function boot() {
    initAllSizeFinders(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllSizeFinders(event.target);
  });

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) return;

        initAllSizeFinders(node);

        const pickers = [];
        if (node.matches && node.matches('variant-picker[data-product-id]')) {
          pickers.push(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('variant-picker[data-product-id]').forEach(function (picker) {
            pickers.push(picker);
          });
        }

        pickers.forEach(function (picker) {
          const id = picker.getAttribute('data-product-id');
          const finder = document.querySelector('[data-ds-size-finder][data-product-id="' + id + '"]');
          if (!finder || typeof finder.__dsRestoreSizeConfidence !== 'function') return;

          finder.__dsRestoreSizeConfidence();
        });
      });
    });
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();